var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({attrs:{"label":_vm.attribute.mandatory ? (_vm.$attrs.label + ' *') : _vm.$attrs.label,"counter":_vm.attribute.maxLength,"rules":_vm.rules}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }